import { render } from "./CreatePartnerPage.vue?vue&type=template&id=d6d8d970"
import script from "./CreatePartnerPage.vue?vue&type=script&lang=js"
export * from "./CreatePartnerPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__